import { render, staticRenderFns } from "./Typing.vue?vue&type=template&id=380e21aa&scoped=true&"
var script = {}
import style0 from "./Typing.vue?vue&type=style&index=0&id=380e21aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380e21aa",
  null
  
)

export default component.exports